import http from '@/services/http'

export default {
  name: 'DownloadBtn',
  props: {
    url: {
      type: String
    },
    /**
     * должна возвращать промис
     */
    updloadFunc: {
      type: Function
    },
    btnText: {
      type: String,
      default: 'Выбрать файл'
    },
    accept: {
      type: String,
      default: '*'
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async onUploadFile(event) {
      const files = event.target.files
      const formData = new FormData(this.$refs.form)
      const promise = this.url ? http.post(this.url, formData) : 
            this.updloadFunc ? this.updloadFunc(formData) : null
      if (files.length && promise) {
        try {
          this.loading = true
          await promise
          this.$emit('success')
          event.target.value = ''
          this.loading = false
        } catch(e) {
          event.target.value = ''
          this.loading = false
          throw e
        }
        
      }
    }
  }
}